import React, { useEffect } from 'react';
import { InputDate, InputSelect } from '~/components/NovosInputs';
import { ContainerInputs } from './styles';
import { operacao } from '../../utils/operacao';
import { pisCofins } from '../../utils/pis-cofins';
import { tipoNaoIncidencia } from '../../utils/tipo-nao-incidencia';
import { useApuracaoDePisCofins } from '../../hooks/useApuracaoDePisCofins';

export const ScreenInputs: React.FC = () => {
  const {
    formTela,
    disableForm,
    disableTipoNaoIncidencia,
    onChangeDisableTipoNaoIncidencia,
    containerInputsRef,
    loading,
    focusInput,
    setFocusInput,
    periodo,
    setPeriodo,
  } = useApuracaoDePisCofins();

  const {
    register,
    control,
    setValue,
    clearErrors,
    resetField,
    formState: { errors },
  } = formTela;

  const optionsPeriodo = [
    { label: 'Selecionar', value: -1 },
    { label: 'Mês Anterior', value: 1 },
    { label: 'Mês Atual', value: 2 },
  ];

  // Condição para data e período
  useEffect((): void => {
    const today = new Date();
    let year = today.getFullYear();
    const month = today.getMonth() + 1;
    let lastMonth = today.getMonth();

    if (periodo) {
      clearErrors('dta_inicio');
      clearErrors('dta_fim');
      // preencher data com mês anterior
      if (periodo.value === 1) {
        // caso esteja em janeiro, pegar mês anterior com base no ano anterior (dezembro)
        if (lastMonth === 0) {
          lastMonth = 12;
          year -= 1;
        }
        const dta_inicio = new Date(year, lastMonth - 1, 1);
        const dta_fim = new Date(year, lastMonth, 0);
        setValue('dta_inicio', dta_inicio.toLocaleDateString('en-CA'));
        setValue('dta_fim', dta_fim.toLocaleDateString('en-CA'));
        return;
      }

      // preencher data com mês atual
      if (periodo.value === 2) {
        const dta_inicio = new Date(year, month - 1, 1);
        const dta_fim = today;

        setValue('dta_inicio', dta_inicio.toLocaleDateString('en-CA'));
        setValue('dta_fim', dta_fim.toLocaleDateString('en-CA'));
        return;
      }
      setValue('dta_inicio', '');
      setValue('dta_fim', '');
    }
  }, [periodo, clearErrors, setValue]);

  const focusInputById = (inputId: string) => {
    const inputElement = document.getElementById(inputId);
    if (inputElement) {
      inputElement.click();
      inputElement.focus();
    }
  };

  useEffect(() => {
    if (focusInput) {
      focusInputById('periodo');
    }
    setFocusInput(false);
  }, [focusInput]);

  return (
    <ContainerInputs ref={containerInputsRef}>
      <div className="inputs-date">
        <InputSelect
          id="periodo"
          label="Período"
          placeholder="Selecione"
          name="periodo"
          disabled={disableForm || loading}
          register={register}
          isError={false}
          control={control}
          changeSelected={(selected) => {
            clearErrors('periodo');
            setValue('periodo', selected);
            setPeriodo(selected);
            if (selected.value === -1) {
              setTimeout(() => {
                focusInputById('dta_incio');
              }, 50);
            }
          }}
          options={optionsPeriodo}
          style={{ width: '8rem' }}
        />
        <InputDate
          id="dta_incio"
          label="Início:"
          register={register}
          name="dta_inicio"
          disabled={disableForm || loading || periodo.value !== -1}
          isError={!!errors.dta_inicio}
          control={control}
          onInput={(ev: any) => {
            clearErrors('dta_inicio');
            setValue('dta_inicio', ev.target.value);
          }}
        />
        <InputDate
          label="Término:"
          register={register}
          name="dta_fim"
          disabled={disableForm || loading || periodo.value !== -1}
          isError={!!errors.dta_fim}
          control={control}
          onInput={(ev: any) => {
            clearErrors('dta_fim');
            setValue('dta_fim', ev.target.value);
          }}
        />
      </div>
      <div className="inputs-seletor">
        <InputSelect
          label="Operação:"
          placeholder="Todos"
          name="tipo_operacao"
          register={register}
          isError={!!errors.tipo_operacao}
          control={control}
          options={operacao}
          disabled={disableForm || loading}
          changeSelected={(selected) => {
            setValue('tipo_operacao', selected);
          }}
        />
        <InputSelect
          label="PIS/COFINS:"
          placeholder="Todos"
          name="flg_nao_pis_cofins"
          register={register}
          isError={!!errors.flg_nao_pis_cofins}
          control={control}
          options={pisCofins}
          disabled={disableForm || loading}
          changeSelected={(selected) => {
            setValue('flg_nao_pis_cofins', selected);
            onChangeDisableTipoNaoIncidencia(selected.value !== 1);

            if (selected.value !== 1) {
              resetField('tipo_nao_pis_cofins', {
                defaultValue: tipoNaoIncidencia[0],
              });
              setValue('tipo_nao_pis_cofins', tipoNaoIncidencia[0]);

              if (containerInputsRef.current) {
                const input: HTMLInputElement | null =
                  containerInputsRef.current.querySelector(
                    '[name="tipo_nao_pis_cofins"]',
                  );

                if (input) input.value = 'Todos';
              }
            }
          }}
        />
        <InputSelect
          label="Tipo Ñ Inc.:"
          placeholder="Todos"
          name="tipo_nao_pis_cofins"
          register={register}
          isError={!!errors.tipo_nao_pis_cofins}
          control={control}
          isDisabled={disableTipoNaoIncidencia || disableForm || loading}
          disabled={disableTipoNaoIncidencia || disableForm || loading}
          options={tipoNaoIncidencia}
          changeSelected={(selected) => {
            setValue('tipo_nao_pis_cofins', selected);
          }}
        />
      </div>
    </ContainerInputs>
  );
};
